import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const CATEGORIES = [
  { key:'all',     label:'All Packages' },
  { key:'kashmir', label:'Kashmir' },
  { key:'ladakh',  label:'Ladakh' },
  { key:'combo',   label:'Combo Tours' },
];

const DURATIONS = ['All Durations','1-3 Nights','4-5 Nights','6-7 Nights','8+ Nights'];
const BUDGETS   = ['Any Budget','Under ₹15,000','₹15,000–₹25,000','₹25,000–₹40,000','₹40,000+'];

export default function Tours() {
  const [tours, setTours]       = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [category, setCategory] = useState('all');
  const [duration, setDuration] = useState('All Durations');
  const [budget, setBudget]     = useState('Any Budget');
  const [sort, setSort]         = useState('popular');

  useEffect(() => {
    axios.get('/api/tours').then(r => {
      setTours(r.data);
      setFiltered(r.data);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  useEffect(() => {
    let result = [...tours];
    if (category !== 'all') result = result.filter(t => t.category === category);
    if (duration !== 'All Durations') {
      result = result.filter(t => {
        if (duration === '1-3 Nights') return t.nights <= 3;
        if (duration === '4-5 Nights') return t.nights >= 4 && t.nights <= 5;
        if (duration === '6-7 Nights') return t.nights >= 6 && t.nights <= 7;
        if (duration === '8+ Nights')  return t.nights >= 8;
        return true;
      });
    }
    if (budget !== 'Any Budget') {
      result = result.filter(t => {
        const p = t.discountedPrice;
        if (budget === 'Under ₹15,000')       return p < 15000;
        if (budget === '₹15,000–₹25,000')     return p >= 15000 && p <= 25000;
        if (budget === '₹25,000–₹40,000')     return p >= 25000 && p <= 40000;
        if (budget === '₹40,000+')             return p > 40000;
        return true;
      });
    }
    if (sort === 'popular')   result.sort((a,b) => (b.reviewCount||0) - (a.reviewCount||0));
    if (sort === 'price-asc') result.sort((a,b) => a.discountedPrice - b.discountedPrice);
    if (sort === 'price-desc')result.sort((a,b) => b.discountedPrice - a.discountedPrice);
    if (sort === 'rating')    result.sort((a,b) => (b.rating||0) - (a.rating||0));
    setFiltered(result);
  }, [category, duration, budget, sort, tours]);

  return (
    <div>
      {/* Page Hero */}
      <div className="page-hero" style={{ backgroundImage:"url('https://images.unsplash.com/photo-1661747340818-df15f186554e?w=1600&q=85')" }}>
        <div className="container" style={{ position:'relative', zIndex:1 }}>
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <span className="breadcrumb-sep">›</span>
            <span>Packages</span>
          </div>
          <h1>Kashmir Tour Packages</h1>
          <p>Discover {tours.length}+ curated packages — from romantic honeymoons to family adventures and high-altitude Ladakh expeditions.</p>
        </div>
      </div>

      <section className="section" style={{ background:'var(--bg)', paddingTop:'3rem' }}>
        <div className="container">

          {/* Filter Bar */}
          <div style={{ background:'var(--surface)', borderRadius:'var(--radius-lg)', padding:'1.5rem 2rem', marginBottom:'2.5rem', boxShadow:'var(--shadow-sm)', display:'flex', gap:'1rem', alignItems:'center', flexWrap:'wrap', border:'1px solid var(--border)' }}>
            <div style={{ display:'flex', gap:'0.5rem', flexWrap:'wrap', flex:1 }}>
              {CATEGORIES.map(c => (
                <button key={c.key} onClick={() => setCategory(c.key)}
                  className={`btn btn-sm${category === c.key ? ' btn-primary' : ' btn-outline'}`}>
                  {c.label}
                </button>
              ))}
            </div>
            <div style={{ display:'flex', gap:'0.75rem', flexWrap:'wrap', alignItems:'center' }}>
              <select value={duration} onChange={e => setDuration(e.target.value)} className="input" style={{ width:'auto', padding:'0.55rem 1rem', fontSize:'0.85rem' }}>
                {DURATIONS.map(d => <option key={d}>{d}</option>)}
              </select>
              <select value={budget} onChange={e => setBudget(e.target.value)} className="input" style={{ width:'auto', padding:'0.55rem 1rem', fontSize:'0.85rem' }}>
                {BUDGETS.map(b => <option key={b}>{b}</option>)}
              </select>
              <select value={sort} onChange={e => setSort(e.target.value)} className="input" style={{ width:'auto', padding:'0.55rem 1rem', fontSize:'0.85rem' }}>
                <option value="popular">Most Popular</option>
                <option value="rating">Highest Rated</option>
                <option value="price-asc">Price: Low to High</option>
                <option value="price-desc">Price: High to Low</option>
              </select>
            </div>
          </div>

          {/* Results count */}
          <div style={{ marginBottom:'1.5rem', display:'flex', alignItems:'center', justifyContent:'space-between' }}>
            <p style={{ fontWeight:600, color:'var(--heading)', fontSize:'0.95rem' }}>
              {loading ? 'Loading...' : `${filtered.length} packages found`}
            </p>
          </div>

          {/* Grid */}
          {loading ? (
            <div className="grid-3" style={{ gap:'1.5rem' }}>
              {[1,2,3,4,5,6].map(i => <div key={i} className="skeleton" style={{ height:380 }} />)}
            </div>
          ) : filtered.length === 0 ? (
            <div style={{ textAlign:'center', padding:'5rem 2rem' }}>
              <div style={{ fontSize:'3rem', marginBottom:'1rem' }}>🔍</div>
              <h3 style={{ color:'var(--heading)', marginBottom:'0.5rem' }}>No packages found</h3>
              <p>Try adjusting your filters to find the perfect package.</p>
              <button className="btn btn-primary" style={{ marginTop:'1.5rem' }} onClick={() => { setCategory('all'); setDuration('All Durations'); setBudget('Any Budget'); }}>
                Clear Filters
              </button>
            </div>
          ) : (
            <div className="grid-3" style={{ gap:'1.5rem' }}>
              {filtered.map((tour, i) => (
                <div key={tour._id} className="tour-card" style={{ animationDelay:`${i*0.05}s` }}>
                  <div className="tour-card-img">
                    <img src={tour.coverImage} alt={tour.title} loading="lazy" />
                    <div style={{ position:'absolute', top:'1rem', left:'1rem' }}>
                      <span className="badge badge-white">{tour.category === 'ladakh' ? '🏔️ Ladakh' : '🌿 Kashmir'}</span>
                    </div>
                    {tour.isFeatured && (
                      <div style={{ position:'absolute', top:'1rem', right:'1rem' }}>
                        <span className="badge badge-accent">Featured</span>
                      </div>
                    )}
                    <div className="tour-card-price-badge">
                      ₹{tour.discountedPrice?.toLocaleString('en-IN')}
                    </div>
                  </div>
                  <div className="tour-card-body">
                    <div className="tour-card-meta">
                      <span>🕐 {tour.duration}</span>
                      <span>👥 Max {tour.maxGroupSize}</span>
                      <span style={{ textTransform:'capitalize' }}>🏔️ {tour.difficulty}</span>
                    </div>
                    <div className="tour-card-title">{tour.title}</div>
                    <div className="tour-card-dests">📍 {tour.destinations?.slice(0,3).join(' · ')}</div>

                    {/* Inclusions chips */}
                    <div style={{ display:'flex', flexWrap:'wrap', gap:'0.35rem', margin:'0.75rem 0' }}>
                      {['Hotel','Meals','Guide','Transfers'].map((inc,j) => (
                        <span key={j} style={{ padding:'0.2rem 0.6rem', background:'rgba(58,175,169,0.10)', color:'var(--secondary-dark)', borderRadius:100, fontSize:'0.72rem', fontWeight:600, fontFamily:"'Poppins',sans-serif" }}>{inc}</span>
                      ))}
                    </div>

                    <div className="tour-card-footer">
                      <div className="tour-card-rating">
                        <span className="stars">★</span>
                        <span style={{ fontWeight:700, color:'var(--heading)' }}>{tour.rating}</span>
                        <span style={{ color:'var(--muted)', fontSize:'0.8rem' }}>({tour.reviewCount})</span>
                      </div>
                      <div style={{ display:'flex', alignItems:'center', gap:'0.6rem' }}>
                        {tour.price > tour.discountedPrice && (
                          <span style={{ textDecoration:'line-through', color:'var(--muted)', fontSize:'0.82rem' }}>₹{tour.price?.toLocaleString('en-IN')}</span>
                        )}
                        <Link to={`/tours/${tour.slug}`} className="btn btn-primary btn-sm">View Details</Link>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>

      {/* Custom Package CTA */}
      <section style={{ background:'var(--surface)', padding:'4rem 0', borderTop:'1px solid var(--border)' }}>
        <div className="container" style={{ textAlign:'center' }}>
          <h2 style={{ fontFamily:"'Playfair Display',serif", marginBottom:'0.75rem' }}>Can't find the right package?</h2>
          <p style={{ maxWidth:500, margin:'0 auto 2rem', lineHeight:1.7 }}>Tell us your dream Kashmir experience and we'll craft a personalised itinerary just for you — at no extra charge.</p>
          <div style={{ display:'flex', gap:'1rem', justifyContent:'center', flexWrap:'wrap' }}>
            <Link to="/contact" className="btn btn-primary btn-lg">Request Custom Package</Link>
            <a href="https://wa.me/919876543210" target="_blank" rel="noopener noreferrer" className="btn btn-secondary btn-lg">💬 WhatsApp Us</a>
          </div>
        </div>
      </section>

      {/* WhatsApp FAB */}
      <a href="https://wa.me/919876543210" target="_blank" rel="noopener noreferrer" className="whatsapp-fab">💬</a>
    </div>
  );
}
